import { Dialog, DialogContent, Grid, Slide } from "@material-ui/core";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import MuiButton from "Components/MuiButton/MuiButton";
import { useSetState } from "Helpers/Hooks";
import { read } from "Helpers/LocalStorage";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import FactorService from "Services/http/endpoints/factor/FactorService";
import Translator from "Languages/Utility/Translator";
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/core/styles";
import PageTitle from "Components/PageTitle/PageTitle";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import * as Icons from "react-bootstrap-icons";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ArchiveFactorDialog = ({ disabled }) => {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const { selectedProject } = useSelector((state) => ({
    selectedProject: state.project.selectedProject,
  }));
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const reportRef = useRef(null);
  const [scale, setScale] = useState(1);
  const [controls, setControls] = useSetState({
    IdFactor: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
  });

  const handlePrint = useReactToPrint({
    content: () => {
      if (reportRef.current) reportRef.current.style.transform = "scale(1)";
      return reportRef.current;
    },
    onBeforeGetContent: () => {
      setLoading(true);
    },
    onAfterPrint: () => {
      if (reportRef.current)
        reportRef.current.style.transform = `scale(${scale})`;
      setLoading(false);
    },
  });

  useEffect(() => {
    if (data) {
      const scaleReport = () => {
        const reportElement = reportRef.current;
        if (reportElement) {
          const container = window.innerWidth;
          const reporter = reportElement.offsetWidth + 80;
          if (container > reporter) {
            setScale(1);
          } else if (reporter > 0) {
            const scaleFactor = container / reporter;
            setScale(scaleFactor);
          }
        }
      };
      setTimeout(scaleReport, 0);
      window.addEventListener("resize", scaleReport);
      return () => window.removeEventListener("resize", scaleReport);
    }
  }, [data]);

  const handleDialog = async () => {
    setOpen(!open);
    if (!open) {
      try {
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdProject: selectedProject.Id,
        };
        const response = await FactorService.getListArchiveFactorProject(
          params
        );
        const updatedData = response.data.Value.map((data) => {
          return {
            ...data,
            label: `${data.Sho} _ ${data.Tarikh} _ ${t(
              "price"
            )} : ${data.Price.toLocaleString()} ${t("moneyUnit")}`,
            value: data.Id,
          };
        });
        setControls({ IdFactor: { selectItems: updatedData } });
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
  };

  const onClickPreview = async () => {
    try {
      setLoading(true);
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        IdProject: selectedProject.Id,
        IdFactor: controls.IdFactor.value.value,
      };
      const response = await FactorService.shoFactorArchive(data);
      if (response.data.Value) {
        setOpen(true);
        setData(response.data.Value.FactorJson);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
  };

  return (
    <>
      <MuiButton
        color="secondary"
        title={<Translator id={"factorArchive"} />}
        onClick={handleDialog}
        disabled={disabled}
      />
      <Dialog
        dir={direction}
        fullScreen
        open={open}
        onClose={handleDialog}
        TransitionComponent={Transition}
      >
        <div className="dialogHeader">
          <BackDropLoading loading={loading} />
          <div className="page-top-title-button w-100">
            <PageTitle title={<Translator id="factorArchive" />} />
            <div className="report-buttons">
              <MuiIconButton
                onClick={handlePrint}
                title={<Translator id={"print"} />}
                className="primary-button"
                icon={<Icons.Printer size={17} />}
              />
              <MuiIconButton
                onClick={handleDialog}
                title={<Translator id="enseraf" />}
                className="danger-fill"
                icon={<Icons.XLg size={17} />}
              />
            </div>
          </div>
        </div>
        <DialogContent className="px-2 pt-3">
          <Grid container spacing={2} className="my-4 pb-2 border-bottom">
            <Grid item md={6} sm={8} xs={12}>
              <MuiAutoComplete
                placeholder={t("select_archived_invoice")}
                options={controls.IdFactor.selectItems}
                label={<Translator id={"invoices"} />}
                value={controls.IdFactor.value}
                id="IdFactor"
                onChange={autoCompleteHandler}
              />
            </Grid>
            <Grid item md={6} sm={4} xs={12} className="margin-top-button">
              <MuiButton
                loading={loading}
                color="secondary"
                title={<Translator id={"display"} />}
                onClick={onClickPreview}
                disabled={!controls.IdFactor.value.value}
                fullwidthOnSm
              />
            </Grid>
          </Grid>
          <div className="printPaper">
            {data && (
              <div
                className="inner-page"
                id={"PrintTest"}
                ref={reportRef}
                style={{ transform: `scale(${scale})` }}
                dangerouslySetInnerHTML={{ __html: data }}
              />
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ArchiveFactorDialog;
